import {
  DrawerContent,
  DrawerTrigger,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerClose,
  Separator,
  Button,
  Drawer,
  Form,
} from '@ui/components';
import { CostCenterFormType } from '@pages/cost-centers/utils';
import { Cancel, Plus } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { CostCenterDocumentsForm } from '../cost-center-documents-form/cost-center-documets-form';
import { CostCenterSettingsForm } from '../cost-center-settings-form/cost-center-settings-form';
import { CostCenterAssignForm } from '../cost-center-assign-form/cost-center-assign-form';
import { useCreateCostCenterDrawer } from './use-create-cost-center-drawer';
import { CostCenterForm } from '../cost-center-form/cost-center-form';

export const CreateCostCenterDrawer = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const {
    onSubmit,
    form: createForm,
    isPending,
  } = useCreateCostCenterDrawer({
    onSuccess: () => {
      setIsOpen(false);
      form.reset();
    },
  });

  const form = createForm as CostCenterFormType;

  return (
    <Drawer
      onClose={() => {
        form.reset();
      }}
      onOpenChange={setIsOpen}
      open={isOpen}
      handleOnly
    >
      <DrawerTrigger asChild>
        <Button type="button">
          <Plus />
          {t('COST_CENTERS.ADD_COST_CENTER')}
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className="flex">
          <DrawerTitle>{t('COST_CENTERS.CREATE_COST_CENTER_DRAWER_TITLE')}</DrawerTitle>
          <div className="flex ml-auto">
            <DrawerClose asChild>
              <Button variant="ghost" type="button">
                <Cancel />
              </Button>
            </DrawerClose>
          </div>
        </DrawerHeader>
        <div className="overflow-y-auto -my-4">
          <Form {...form}>
            <form className="px-4 space-y-4">
              <CostCenterForm form={form} />
              <Separator />
              <CostCenterSettingsForm form={form} />
              <Separator />
              <CostCenterAssignForm form={form} />
              <Separator />
              <CostCenterDocumentsForm form={form} />
            </form>
          </Form>
        </div>
        <DrawerFooter>
          <Button isLoading={isPending} disabled={isPending} onClick={onSubmit} size="large" wide>
            {t('COST_CENTERS.CREATE_COST_CENTER_DRAWER_SAVE')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
